import usePusher from 'hooks/usePusher';
import { useEffect } from 'react';
import useRepositoryFilesUploadStore from './useRepositoryFilesUploadStore';

const useCleanRepositoryFileStore = () => {
  const channel = usePusher();

  useEffect(() => {
    if (!channel) return;

    const handler = (event: { data: { _id: string } }) => {
      const id = event?.data?._id;
      if (!id) return;
      const files = useRepositoryFilesUploadStore.getState().getValues();
      const file = files.find((fileState) => fileState.result === id);
      if (!file) return;
      useRepositoryFilesUploadStore.getState().remove(file.key);
    };

    channel.bind('repository-document.deleted', handler);
    return () => {
      channel.unbind('repository-document.deleted', handler);
    };
  }, [channel]);
};

export default useCleanRepositoryFileStore;
